 

export const ADMIN_PRODUCTS_DATA_FAIL="ADMIN_PRODUCTS_DATA_FAIL"
export const ADMIN_PRODUCTS_DATA_REQ="ADMIN_PRODUCTS_DATA_REQ"
export const ADMIN_PRODUCTS_DATA_SUCC="ADMIN_PRODUCTS_DATA_SUCC"


 
 

export const ADMIN_PRODUCTS_DATA_SUCC_SEARCH="ADMIN_PRODUCTS_DATA_SUCC_SEARCH"



export const ADMIN_PRODUCTS_DATA_SEARCH="ADMIN_PRODUCTS_DATA_SEARCH"


export const ADMIN_PRODUCTS_DATA_FILTER="ADMIN_PRODUCTS_DATA_FILTER"
// export const ADMIN_PRODUCTS_DATA_ROLE="ADMIN_PRODUCTS_DATA_ROLE"
// export const ADMIN_PRODUCTS_DATA_TYPE="ADMIN_PRODUCTS_DATA_TYPE"